import React, { useContext, useEffect, useRef, useState } from 'react';
import useStyles from '../../../style/js-style/containers/roadmap/RoadmapStyle';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import i18n from '../../../i18n/i18n';
import { Context } from '../../../states/Store';
import {theme} from '../../../style/globalStyle';
import EAColorIcon from '../../../components/common/EAColorIcon';

function RoadMapItem({index, item, tab, handleClickItem}) {
  const { classes } = useStyles();
  const [showReadMore, setShowReadMore] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const titleRef = useRef(null);
  const [maxSizeWithImg, setMaxSizeWithImg] = useState(150);
  const [maxSizeWithoutImg, setMaxSizeWithoutImg] = useState(300);
  const [state] = useContext(Context);

  // Ajoute un évènement pour traquer la width de la page
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Calcule le nombre de caractères à afficher (approximation)
  useEffect(() => {
    if (titleRef.current) {
      const totalCardHeight = 257;
      const imageHeight = 140;
      const reductionFactor = 400;
      const titleHeight = titleRef.current.offsetHeight;
      const width = titleRef.current.offsetWidth;

      setMaxSizeWithImg(Math.round(((totalCardHeight - titleHeight - imageHeight) * width) / reductionFactor));
      setMaxSizeWithoutImg(Math.round(((totalCardHeight - titleHeight) * width) / reductionFactor));
    }
  }, [windowWidth]);

  // Affiche le "Lire" quand la hauteur réél dépasse la hauteur visible
  useEffect(() => {
    setShowReadMore(contentRef.current.offsetHeight < wrapperRef.current.scrollHeight);
  }, [windowWidth]);

  return (
    <Card key={index} className={classes.roadmapItemWrapper} ref={wrapperRef}>
      <CardActionArea onClick={() => handleClickItem({...item, category: tab.id })}>
        <CardContent
          className={
            item.imageURI
              ? classes.roadmapContentWrapperWithImage
              : classes.roadmapContentWrapperWithoutImage
          }

        >
          <div
            className={classes.roadmapItemTitle}
            ref={titleRef}
            style={{
              color: state.personalization.isCustomTemplate
                ? theme.palette.black.dark
                : theme.palette.primary.primary800
            }}
          >
            <EAColorIcon
              icon={`/roadmap/${tab.id}`}
              svgStyle={{ marginRight: '10px' }}
            />
            {item.title}
          </div>
          <div className={classes.roadmapItemContent} ref={contentRef}>
            {showReadMore
              ? (
                <>
                  {item.content.substring(0, !item.imageURI && item.content.length > maxSizeWithoutImg ? maxSizeWithoutImg : maxSizeWithImg)}
                  ...
                  <span className={classes.readMore}> {i18n.t("read")}</span>
                </>
              ) : item.content
            }
          </div>
        </CardContent>

        {/* Illustration */}
        {item.imageURI && (
          <div style={{ backgroundColor: '#00000040'}} >
            <CardMedia
              component="img"
              height="140"
              image={item.imageURI}
              alt={item.imageURI}
              sx={{ opacity: 0.5 }}
            />
          </div>
        )}
      </CardActionArea>
    </Card>

  );
}

export default RoadMapItem;
